import { useEffect, useMemo, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import styled from "styled-components";
import theme from "../styles/theme";
import Button from "./Button";
import FlexBox, { FlexGrow } from "./FlexBox";
import Input, { InputTextArea } from "./Input";
import { StyledText } from "./Text";
import { ClickableIcon } from "./Icon";
import { useScreenClass } from "react-grid-system";
import Modal from "./Modal";
import { Checkbox } from "@mui/material";
import MinimalSelect from "./MinimalSelect";
import ReactSelect from "react-select";
import axios from "axios";
type VersionCreateType = {
  isOpen?: boolean;
  isSuperUser?: boolean;
  header: string;
  mode: "modify" | "create";
  setOpen: (x: boolean) => void;
  versionData?: {
    id: string;
    title: string;
    university_code: string;
  };
  onSaveComplete: (data: any) => void;
};

const Header = styled.h4`
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0px;
  text-align: left;
`;
const CustomFlex = styled(FlexBox)`
  padding: 20px 0;
  align-items: center;
  border-bottom: 1px solid #3c406c;
`;
const CustomFlexPlain = styled(FlexBox)`
  padding: 5px 0;
  align-items: flex-start;
`;
const CustomGrowPlain = styled(FlexGrow)`
  min-width: 150px;
  flex-grow: 0;
`;
const Label = styled.h5`
  font-size: 14px;
  // font-style: normal;
  // font-weight: 700;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
`;
interface VersionInputs {
  title: string;
  university_code: any;
  source_university: string;
  version: string;
  is_clone: boolean;
  program: string;
  target_program: string;
}
interface universityOptions {
  value: string;
  label: string;
}

const VersionCreate = ({
  isOpen,
  setOpen,
  isSuperUser,
  header,
  mode,
  versionData,
  onSaveComplete,
}: VersionCreateType): JSX.Element => {
  const screenClass = useScreenClass();
  const [openTopic, setOpenTopic] = useState<boolean>(false);
  const [cloneCheck, setCloneCheck] = useState<boolean>(true);
  const [selectedOption, setSelectedOption] = useState<boolean>(true);
  const [programOptions, setProgramOptions] = useState<any[]>([]);
  const [targetProgramOptions, setTargetProgramOptions] = useState<Array<any>>(
    []
  );

  const [currUniversity, setCurrentUniversity] = useState<any>(
    localStorage.getItem("university")
  );
  
  const [universities, setUniversities] = useState<Array<any>>([]);
  const [targetUni, setTargetUni] = useState(currUniversity);
  const [sourceProgramName, setSourceProgramName] = useState("");

  const {
    register,
    handleSubmit,
    control,
    watch,
    reset,
    setValue,
    control: controlOverview,
    formState: { errors },
  } = useForm<VersionInputs>({
    mode: "onBlur",
    defaultValues: {
      title: versionData ? versionData.title : "",
      university_code: versionData
        ? versionData.university_code
        : currUniversity,
      is_clone: true,
    },
  });
  useEffect(() => {
    universities?.length === 0 && getUniversities();
    sourceProgramName && getAllVersion();
  }, [sourceProgramName]);

  //// for source university option
  useEffect(() => {
    if (!currUniversity) return;

    axios
      .get(`/university?university_code=${currUniversity}`)
      .then((res) => {
        const list = res.data.universities[0].program.map((p: any) => ({
          label: p.short_name,
          value: p.id,
          short_name: p.short_name,
        }));
        setProgramOptions(list);
      })
      .catch(() => {});
  }, [currUniversity]);

  //for target university option
  useEffect(() => {
    if (!targetUni) return;
    getTargetPrograms(targetUni);
  }, [targetUni]);

  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const onSubmitOverview: SubmitHandler<VersionInputs> = (fdata: any) => {
    onSaveComplete({
      title: fdata.title,
      is_clone: fdata.is_clone,
      university_code: fdata.university_code.value || currUniversity,
      source_version: fdata?.version?.value,
      source_program_id: fdata?.program?.value,
      target_program_id: fdata?.target_program?.value,
    });
  };

  const [versions, setVersions] = useState<Array<any>>([]);

  const getUniversities = () => {
    axios
      .get("/university")
      .then((res) => {
        const transformedArray = res.data.universities?.map((item: any) => ({
          value: item.short_name,
          label: item.short_name,
        }));

        setUniversities(transformedArray);
      })
      .catch(() => {});
  };

  const getAllVersion = () => {
    axios
      .get(
        `/version?university_code=${currUniversity}&program_name=${sourceProgramName}`
      )
      .then((res) => {
        const transformedArray = res.data.versions?.map((item: any) => ({
          value: item.version_number,
          label: item.title + " : " + item.display_version,
        }));
        setVersions(transformedArray);
      })
      .catch(() => {});
  };

  const handleChange = (selected: any) => {
    setSelectedOption(selected);
  };

  const getTargetPrograms = (university: string) => {
    axios
      .get(`/university?university_code=${university}`)
      .then((res) => {
        const list = res.data.universities[0].program.map((p: any) => ({
          label: p.short_name,
          value: p.id,
        }));
        setTargetProgramOptions(list);
      })
      .catch(() => {});
  };
  return (
    <>
      <Modal
        isOpen={isOpen || false}
        setOpen={setOpen}
        customStyle={{
          overlay: {
            zIndex: "999958",
          },
          content: {
            maxWidth: "500px",
            padding: "0 24px",
            color: "black",
            background: "#FFFFFF",
            border: "1px solid #E7EBEE",
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.07)",
            borderRadius: "8px",
          },
        }}
      >
        <CustomFlex>
          <FlexGrow>
            <Header>{header}</Header>
          </FlexGrow>
          <ClickableIcon
            size={3.125}
            fixedWidth={false}
            color="black"
            name="close"
            onClick={() => setOpen(false)}
          />
        </CustomFlex>
        {/* <CustomFlex
          style={{
            borderBottom: "none",
            alignItems: "flex-start",
            overflowY: "scroll",
          }}
        > */}
        <form
          style={{ padding: "10px 0px 30px 0px" }}
          onSubmit={handleSubmit(onSubmitOverview)}
        >
          {/* <FlexGrow
              style={{
                // position: "relative",
                // borderBottom: "none",
                // alignItems: "flex-start",
                zIndex:1000,
                overflowY: "scroll",
                overflowX: "hidden",
                marginBottom: 20,
              }}
            > */}
          <CustomFlexPlain>
            <CustomGrowPlain>
              <Label>Your University</Label>
            </CustomGrowPlain>

            <FlexGrow>
              <Controller
                name="university_code"
                control={control}
                render={({ field }) => (
                  <ReactSelect
                    isDisabled={!isSuperUser}
                    {...register("university_code", { required: true })}
                    {...field}
                    value={universities.find(
                      (c: any) => c.value === field.value
                    )}
                    options={universities}
                    onChange={(selected) => {
                      field.onChange(selected);
                      setTargetUni(selected.value);
                      handleChange(selected);
                    }}
                  />
                )}
              />
              {errors.university_code && (
                <p
                  style={{
                    marginTop: 0,
                    color: theme.color.red800,
                  }}
                >
                  This field is required
                </p>
              )}
            </FlexGrow>
          </CustomFlexPlain>

          <CustomFlexPlain>
            <CustomGrowPlain>
              <Label>Your Program</Label>
            </CustomGrowPlain>

            <FlexGrow>
              <Controller
                name="target_program"
                control={control}
                // defaultValue={null} // Set default value
                render={({ field }) => (
                  <ReactSelect
                    {...register("target_program", { required: true })}
                    {...field}
                    options={targetProgramOptions}
                    onChange={(selected) => {
                      field.onChange(selected);
                    }}
                  />
                )}
              />
              {errors.university_code && (
                <p
                  style={{
                    marginTop: 0,
                    color: theme.color.red800,
                  }}
                >
                  This field is required
                </p>
              )}
            </FlexGrow>
          </CustomFlexPlain>

          <CustomFlexPlain>
            <CustomGrowPlain>
              <Label>Version Title</Label>
            </CustomGrowPlain>
            <FlexGrow>
              <Input
                style={{ width: "100%" }}
                isFullWidth
                {...register("title", { required: true })}
              />
              {errors.title && (
                <p
                  style={{
                    marginTop: 0,
                    color: theme.color.red800,
                  }}
                >
                  This field is required
                </p>
              )}
            </FlexGrow>
          </CustomFlexPlain>

          <FlexGrow
            style={{
              flexGrow: "0",
              marginLeft: -10,
              fontSize: 14,
              alignItems: "center",
              display: "flex",
            }}
          >
            <Checkbox
              {...register("is_clone", { required: false })}
              checked={cloneCheck}
              onChange={(e) => {
                setCloneCheck(!cloneCheck);
              }}
              sx={{
                color: "#677489",
                "&.Mui-checked": {
                  color: "#677489",
                },
              }}
            />{" "}
            Clone Version
          </FlexGrow>
          {cloneCheck && (
            <>
              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Source University</Label>
                </CustomGrowPlain>

                <FlexGrow>
                  <Controller
                    name="university_code"
                    control={control}
                    render={({ field }) => (
                      <ReactSelect
                        isDisabled={true}
                        {...register("university_code", { required: true })}
                        {...field}
                        value={universities.find(
                          (c: any) => c.value === currUniversity
                        )}
                        options={universities}
                        onChange={(selected) => {
                          field.onChange(selected);
                          handleChange(selected);
                        }}
                      />
                    )}
                  />
                  {errors.university_code && (
                    <p
                      style={{
                        marginTop: 0,
                        color: theme.color.red800,
                      }}
                    >
                      This field is required
                    </p>
                  )}
                </FlexGrow>
              </CustomFlexPlain>

              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Source Program</Label>
                </CustomGrowPlain>

                <FlexGrow>
                  <Controller
                    name="program"
                    control={control}
                    render={({ field }) => (
                      <ReactSelect
                        {...register("program", { required: true })}
                        {...field}
                        options={programOptions}
                        onChange={(selected: any) => {
                          field.onChange(selected);
                          setSourceProgramName(selected?.short_name);

                          setValue("version", ""); 
                          setVersions([]);
                        }}
                      />
                    )}
                  />
                  {errors.university_code && (
                    <p
                      style={{
                        marginTop: 0,
                        color: theme.color.red800,
                      }}
                    >
                      This field is required
                    </p>
                  )}
                </FlexGrow>
              </CustomFlexPlain>

              <CustomFlexPlain>
                <CustomGrowPlain>
                  <Label>Source Version</Label>
                </CustomGrowPlain>

                <FlexGrow>
                  <Controller
                    name="version"
                    control={control}
                    // defaultValue={null} // Set default value
                    render={({ field }) => (
                      <ReactSelect
                        isDisabled={!sourceProgramName}
                        {...register("version", { required: true })}
                        {...field}
                        options={versions}
                        onChange={(selected) => {
                          field.onChange(selected);
                        }}
                      />
                    )}
                  />
                  {errors.university_code && (
                    <p
                      style={{
                        marginTop: 0,
                        color: theme.color.red800,
                      }}
                    >
                      This field is required
                    </p>
                  )}
                </FlexGrow>
              </CustomFlexPlain>
            </>
          )}
          <FlexBox>
            <FlexGrow></FlexGrow>
            <Button
              className="reduce_opct_onhover"
              type="button"
              onClick={() => setOpen(false)}
              style={{
                border: "2px solid #64748B",
                padding: "8px 40px",
                fontSize: "14px",
                width: 120,
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="reduce_opct_onhover"
              style={{
                background: theme.color.blueButton,
                boxShadow: "0 2px 5px #808080cc",
                border: "none",
                width: 120,
                minHeight: 40,
                color: "white",
              }}
            >
              Create
            </Button>
          </FlexBox>
          {/* </FlexGrow> */}
        </form>
        {/* </CustomFlex> */}
      </Modal>
    </>
  );
};
export default VersionCreate;
